export const staticPath = (path: string) => {
  return `https://d2hu8n21aegy8s.cloudfront.net/${path}`;
};
